<template>
  <div class="dash-preview" style="overflow: hidden">
    <div class="container">
      <div class="checkin-detail-header">
        <div class="event-summary mb-3">
          <div class="d-flex justify-content-between justify-content-md-start align-items-start">
            <div class="d-flex align-items-center">
              <div class="event-summary__logo" v-if="data.logo">
                <img :src="data.logo" class="rounded-circle" alt="Event logo">
              </div>
              <div v-else>
                <div class="event-summary__logo-placeholder"></div>
              </div>
              <div>
                <h1 class="event-summary__name" v-if="data.name">{{ data.name }}</h1>
                <template v-else>
                  <div style="width: 180px;height: 12px;margin-bottom: 6px" class="placeholder__text"></div>
                  <div style="width: 180px;height: 12px" class="placeholder__text mb-0"></div>
                </template>
                <h6 class="event-summary__subname" v-if="data.subtitle">{{ data.subtitle }}</h6>
                <div style="width: 90px;height: 12px" class="placeholder__text mt-2" v-else></div>
              </div>
            </div>
            <div>
              <Icon name="dotsVertical" width="33"/>
            </div>
          </div>
        </div>
      </div>

      <!-- GALLERY -->
      <div class="public-gallery">
        <div class="public-gallery__title" v-if="data.gallery && data.gallery.length > 0">
          {{ $t('pages.checkins_detail.public_media') }}
        </div>
        <div style="width: 80px;height: 12px;margin-bottom: 12px" class="placeholder__text" v-else></div>
        <swiper-slider :slides-per-view="5"
                       :space-between="8"
                       :slides-per-group="2"
                       :breakpoints="sliderBreakpoints"
                       :has-navigation="false"
                       :loop="false"
                       :lazy="false"
                       :autoplay="data.gallery.length > 0"
                       :free-mode="true"
                       :selected-index="0"
                       ref="swiperPreview">
          <template v-slot:slides>
            <template v-if="data.gallery && data.gallery.length > 0">
              <div class="swiper-slide swiper-slide--40" v-for="(slide, index) in slides" :key="index">
                <div class="public-gallery__slide">
                  <div class="media-container">
                    <template v-if="isVideo(slide)">
                      <video :src="slide" class="media-item" controls playsinline muted></video>
                    </template>
                    <template v-else>
                      <img :src="slide" alt="" class="media-item">
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="swiper-slide swiper-slide--40" v-for="(index) in 4" :key="index">
                <div class="public-gallery__slide">
                  <div class="media-container">
                    <div class="media-item placeholder__image"></div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </swiper-slider>
      </div>

      <div style="width: 80px;height: 12px;margin-bottom: 12px" class="placeholder__text"></div>

      <div class="row collage-photo">
        <div class="col-6 col-sm-6 col-lg-4 col-xl-3" v-for="(index) in 4" :key="index">
          <div class="collage-photo-item">
            <div class="collage-photo-item__image-container cursor-default">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SwiperSlider from "@/components/SwiperSlider.vue";

const VIDEO_EXTENSIONS = ['mp4', 'avi', 'mkv', 'mov', 'm4v', 'flv', 'wmv', 'webm']
export default {
  name: 'PreviewHome',
  components: {SwiperSlider},
  data() {
    return {
      sliderBreakpoints: {
        140: {
          slidesPerView: 'auto',
          slidesPerGroup: 1
        },
        780: {
          slidesPerView: 2,
          slidesPerGroup: 1
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 1

        },
        1280: {
          slidesPerView: 5,
          slidesPerGroup: 2
        }
      }
    }
  },
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  computed: {
    slides() {
      return this.data.gallery
    }
  },
  watch: {
    slides: function () {
      if (this.slides.length === 0) return
      this.$refs.swiperPreview.update()
    }
  },
  methods: {
    isVideo(url) {
      const extension = url.split('?').shift().split('.').pop().toLowerCase()
      return VIDEO_EXTENSIONS.includes(extension)
    }
  }
}
</script>
